import { useThrottledCallback } from '@fabric-app/hooks/useThrottledCallback';
import React__default, { useContext } from 'react';
import { SocketIOParentRoomContext } from './SocketIOParentRoomContext.js';

const useSocketIOParentRoomEventListener = (event, cb, options) => {
  const enabled = options?.enabled ?? true;
  const throttle = options?.throttle ?? 1e4;
  const socketContext = useContext(SocketIOParentRoomContext);
  const cbThrottledRef = useThrottledCallback(cb, throttle);
  React__default.useEffect(() => {
    if (enabled && socketContext) {
      const { socket } = socketContext;
      const attachFn = cbThrottledRef.current;
      socket.on(event, attachFn);
      return () => {
        socket.off(event, attachFn);
      };
    }
  }, [
    socketContext,
    event,
    enabled,
    cbThrottledRef
  ]);
};

export { useSocketIOParentRoomEventListener };
//# sourceMappingURL=useSocketIOParentRoomEventListener.js.map
